module.exports = __webpack_public_path__ + "media/images/accepterad-05c908b70ccebf529b03c8a60521c890.png";